import { Component, OnInit } from '@angular/core';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { DialogService } from '../../../shared/services/dialog.service';
import { CentreManagementFeeService } from './centre-management-fees.service';
import { ModifyCentreManagementFeesComponent } from './modify-centre-management-fees-popup.component';
import { CentreManagementFeeModel } from '../../../models/master-data/centre-management-fee.model';
import { CentreModel } from '../../../models/centre/centre.model';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'centre-management-fee',
    templateUrl: 'centre-management-fees.component.html',
    providers: [CentreManagementFeeService]
})

export class CentreManagementFeesComponent extends TMBDataTableComponent implements OnInit {
    dataRow = new Array<CentreManagementFeeModel>();
    public category: any;
    public filterData = { centreId: null, centreName: ''};
    centres = new Array<CentreModel>();
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);

    constructor(
        public dialogService: DialogService,
        public utility: Utility,
        public sharedService: SharedService,
        private centreManagementFeeService: CentreManagementFeeService) {
            super(sharedService);
         }

        public centreId = [];

    ngOnInit() {
      const param = {
        id: localStorage.getItem(AppConstants.activeLink.userId),
        userType: localStorage.getItem(AppConstants.localStorage.userType),
      };
        this.getCentre(param);
        this.setPage({ offset: 0 })
    }

    getCentre(param) {
      this.centreManagementFeeService.getAllCentre(param).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.centres = data.filter(
              a => a.associatedClinic === true);
          }
        }
      );
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            selectedCentre: this.currentCentreId, //this.filterData.centreId === 'null' ? '' : this.filterData.centreId,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
        };
        this.centreManagementFeeService.getCentreManagementFees(param.selectedCentre).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => {
            }
        );
    }

    onCentreChange() {
        this.filterData.centreName = '';
        this.centres.forEach(item => {
            if (item.id === this.filterData.centreId) {
                this.filterData.centreName = item.name;
            }
        });
        this.setPage({ offset: 0 })
    }

    onEditItem(id) {
        const data = {
            id: id
        };
        this.dialogService.openComponentDialog(ModifyCentreManagementFeesComponent, data).subscribe(
            (result) => {
                if (result) {
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            }
        );
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/centre-management-fees/centre-management-fees.component.ts